import { mediaUrl } from "../services/media";

// The address of an uploaded photo, track or video, or null for no id.
export default function useMediaUrl(id) {
  return mediaUrl(id);
}
